<template>
  <v-currency-field
    v-if="showInput"
    :error-messages="$props.error"
    :label="$props.label"
    :mask="$props.mask"
    :placeholder="' '"
    :readonly="$props.readonly"
    :type="$props.type"
    outline
    v-bind="currency_config"
    v-model="inputValue"
  ></v-currency-field>
</template>

<script>
export default {
  name: 'CurrencyField',
  props: [
    'simple',
    'value',
    'error',
    'placeholder',
    'label',
    'type',
    'mask',
    'readonly',
  ],
  data() {
    return {
      inputValue: this.$props.value,
      currency_config: {
        locale: 'de',
        prefix: '',
        suffix: '',
        precision: 2,
        'auto-decimal-mode': false,
        allowBlank: false,
        min: 0,
        max: Number.MAX_SAFE_INTEGER,
      },
      showInput: true,
    }
  },
  watch: {
    inputValue() {
      // console.log('change input' + this.inputValue);
      this.$emit('input', this.inputValue)
    },
    value() {
      // console.log('change value' + this.$props.value);
      this.inputValue = this.$props.value
      this.showInput = false
      this.$nextTick(() => {
        this.showInput = true
      })
    },
  },
}
</script>
